// extracted by mini-css-extract-plugin
export var anchor = "_48-0";
export var discard = "_48-4";
export var muiTooltipTooltip = "_48-6";
export var notificationBar = "_48-3";
export var saveButtonHoverSlotWrapper = "_48-5";
export var show = "_48-2";
export var spacer = "_48-1";